<div [ngClass]="setNewDivAndWhiteBackground === true ? 'container-cards-fill':
  'container-cards'">
  <div class="container-ghost">
    <div [ngClass]="setNewDivAndWhiteBackground === true ?
      'card-white-container-shadow': 'card-container-shadow'" class="padding-md
      border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>FECHA DE LA CITA</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-time-limit-100.png"
          alt="">
      </div>
      <div class="strong-text text-title-lg">
        <p>{{ date }}</p>
      </div>
      <div class="text-info">
        <p nz-typography nzEllipsis>{{ hourFrom }} {{ duration ? '(' + duration
          + ')' : ' - ' + hourTo}}</p>
      </div>
    </div>
  </div>
  <div class="container-ghost">
    <div [ngClass]="setNewDivAndWhiteBackground === true ?
      'card-white-container-shadow': 'card-container-shadow'" class="padding-md
      border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>EXPERTO</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-doctor-male-100.png"
          alt="">
      </div>
      <div class="strong-text text-title-lg">
        <p class="truncate expert-name">{{ expertName }}</p>
      </div>
      <div class="text-info">
        <p nz-typography nzEllipsis> {{ expertSpeciality }} </p>
      </div>
    </div>
  </div>
  <div class="container-ghost" *ngIf="(appointmentType ===
    appointmentTypeEnum?.ONE_TO_ONE && note) || (appointmentType !==
    appointmentTypeEnum?.ONE_TO_ONE)">
    <div [ngClass]="setNewDivAndWhiteBackground === true ?
      'card-white-container-shadow': 'card-container-shadow'" class="padding-md
      border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>TIPO DE SERVICIO</p>
        <img loading="lazy"
          src="./../../../assets/images/icons/icons8-rod-of-asclepius-100.png"
          alt="">
      </div>
      <div class="strong-text text-title-lg">
        <p>{{ appointmentType == appointmentTypeEnum?.ONE_TO_ONE && note ?
          'Conferencia' : 'Presencial' }}</p>
      </div>
      <div class="text-info">
        <p nz-typography nzEllipsis>{{ appointmentType == appointmentTypeEnum?.ONE_TO_ONE && note ? 'En línea' : branchName }}</p> <!--(click)="onGotoUrl()"-->
      </div>
    </div>
  </div>
  <div class="container-ghost" *ngIf="note">
    <div [ngClass]="setNewDivAndWhiteBackground === true ?
      'card-white-container-shadow': 'card-container-shadow'" class="padding-md
      border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>ENLACE DE LA SESIÓN</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-notepad-100.png" alt="">
      </div>
      <div class="text-info">
        <p *ngIf="url" class="text-link truncate mb-xxs" (click)="onGotoUrl()">{{ url }}</p>
        <p class="truncate tw-cursor-pointer" nz-typography nzCopyable nz-tooltip [nzTooltipTitle]="note">
          <span class="text-info-sm">Nota:</span> {{ note }}
        </p>
      </div>
    </div>
  </div>
  <div class="container-ghost" *ngIf="!note && location">
    <div [ngClass]="setNewDivAndWhiteBackground === true ?
      'card-white-container-shadow': 'card-container-shadow'" class="padding-md
      border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>UBICACIÓN</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-globe-100.png" alt="">
      </div>
      <div class="text-info" *ngIf="location">
        <p nz-typography nzEllipsis [nzEllipsisRows]="3">{{ location.city + ', '
          + location.state + ', ' + location.suburb + ', ' + location.street }}</p>
      </div>
    </div>
  </div>
  <div class="container-ghost" *ngIf="visibleTotalAppointmentsInService">
    <div [ngClass]="setNewDivAndWhiteBackground === true ?
      'card-white-container-shadow': 'card-container-shadow'" class="padding-md
      border-radius-sm" [ngStyle]="cardStyles">
      <div class="title text-subtitle-bold-upper">
        <p>Citas del servicio</p>
        <img loading="lazy" src="./../../../assets/images/icons/icons8-planner-100.png" alt="">
      </div>
      <div class="strong-text text-title-lg">
        <p> {{totalAppointmentsInService}} </p>
      </div>
    </div>
  </div>
</div>
